module.exports = __webpack_public_path__ + "bootleggers_coffee_mockup_kcup_v1.jpg?247f4519a218c6e145b84fe051a95f9c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_mockup_kcup_v1.jpg
// module id = 39
// module chunks = 0